<div class="loader-container">
  <div class="spinner">
    <img src="./../../../assets/img/loader/spinner.svg" alt="spinner">
  </div>
  <div class="logo" ()>
    <img src="./../../../assets/img/logo_no_name.png" alt="logo_no_name">
  </div>
</div>
